module.exports = __webpack_public_path__ + "static/img/duraframe-with-flush-mount-post.d2ad939.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/duraframes/duraframe-with-flush-mount-post.jpg
// module id = 733
// module chunks = 0